<template>
  <div :class="`form-group ${error ? 'has-error' : ''}`">
    <label v-show="label" class="control-label">
      {{ label }}
      <span v-if="$attrs.required || requiredMark" class="text-danger">*</span>
    </label>
    <input
      class="form-control"
      :type="type || 'text'"
      :id="id"
      :name="name"
      :value="value"
      v-bind="$attrs"
      @blur="$emit('blur', $event.target.value)"
      @input="$emit('input', $event.target.value)"
      @change="$emit('change', $event.target.value)"
    />
    <small class="text-danger" v-if="error" v-html="error"></small>
    <span class="help-block" v-if="help" v-html="help"></span>
  </div>
</template>

<script>
export default {
  props: [
    'value',
    'error',
    'label',
    'help',
    'id',
    'type',
    'name',
    'requiredMark'
  ],
  emits: ['update:modelValue']
}
</script>
